import {createStyles, Theme} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {BACKGROUND_SECONDARY, PRIMARY_RED} from "../../../const/colors";

const BUTTON_WIDTH = 360;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        link: {
            color: PRIMARY_RED,
            cursor: 'pointer',
        },
        radioWrapper: {
            border: `1px solid ${BACKGROUND_SECONDARY}`,
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            fontSize: '20px',
            fontWeight: 700,
            height: 72,
            [theme.breakpoints.down('xs')]: {
                height: 56,
            },
        },
        formControlWrapper: {
            width: '100%',
            height: '100%',
        },
        radio: {marginRight: 8},
        selectedRadioWrapper: {
            backgroundColor: BACKGROUND_SECONDARY,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
        },
        radioText: {
            fontSize: '20px',
            fontWeight: 700,
        },
        optionContent: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
        },
        createAccountImage: {
            display: 'block',
            width: '100%',
            maxWidth: 380,
            height: 'auto',
            margin: '0 auto',
        },
        contentBackground: {
            backgroundColor: BACKGROUND_SECONDARY,
        },
        mojeIDLogo: {
            width: '100px',
            height: '32px',
        },
        notOnTheListButton: {
            cursor: 'pointer',
            maxWidth: BUTTON_WIDTH,
            height: 48,
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            width: BUTTON_WIDTH,
            fontWeight: 'bold',
        },
        registerButtonsWrapper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            gap: 16,
            [theme.breakpoints.up('lg')]: {
                alignItems: 'flex-end',
            },
        },
        signUpButton: {
            fontWeight: 'bold',
            width: '100%',
            [theme.breakpoints.up('lg')]: {
                width: BUTTON_WIDTH,
            },
        },
        microsoftButton: {
            backgroundColor: '#ffffff',
            border: '1px #8c8c8c solid',
            '&:hover': {
                backgroundColor: '#f4f4f4f4'
            },
            width: '100%',
            fontWeight: 'bold',
            [theme.breakpoints.up('lg')]: {
                width: BUTTON_WIDTH,
            }
        },
        mojeIDWrapper: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
            gap: 36,
            [theme.breakpoints.up('lg')]: {
                flexDirection: 'row',
                justifyContent: 'flex-end',
                // minWidth: 327,
            }
        }
    }),
);

export default useStyles;
